// Styles
import './styles.css';

// Core
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import RSVP_CONSTS from '../../../../constants';
import {
    GeckoCol,
    GeckoModal,
    GeckoModalService,
    GeckoToastService
} from '@geckolabs/gecko-react-ui';
import CardStub from '../CardStub';
import SessionSingle from '../../../SessionSingle';
import SessionTime from '../../../SessionTime';
import StatusControl from '../../../profile/StatusControl';

// Services
import RsvpService from '../../../../services/RsvpService';
import RefreshData from '../../../../services/RefreshData';
import SelfCheckinRefreshInterval from '../../../../services/SelfCheckinRefreshInterval';
import WebinarService from '../../../../services/Webinar';
import {__, STR_KEY} from '../../../../services/Translate';

import Utils from '../../../../services/utils/utils';

export default class Session extends Component {

    state = {
        values: {
            sessionTimeId: null
        },
        data: this.props.data,
        event: this.props.event,
        events: this.props.events,
        sessionTime: this.props.sessionTime,
        eventAttendance: this.props.eventAttendance,
        hasBooked: this.props.hasBooked
    }

    rsvpService = new RsvpService();

    // Maybe remove
    UNSAFE_componentWillMount() {
        
        let selectedTimeId = (this.sessionTime() || {}).id || null;

        if (this.sessionTimes().length === 1) {
            
            selectedTimeId = this.sessionTimes()[0].id;
        }

        this.setState({values: {sessionTimeId: selectedTimeId}})
        
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let state = {};

        if(this.props.data !== nextProps.data)                       state['data'] = nextProps.data;
        if(this.props.event !== nextProps.event)                     state['event'] = nextProps.event;
        if(this.props.events !== nextProps.events)                   state['events'] = nextProps.events;
        if(this.props.sessionTime !== nextProps.sessionTime)         state['sessionTime'] = nextProps.sessionTime;
        if(this.props.eventAttendance !== nextProps.eventAttendance) state['eventAttendance'] = nextProps.eventAttendance;
        if(this.props.hasBooked !== nextProps.hasBooked)             state['hasBooked'] = nextProps.hasBooked;

        // update state if component is passed props from a new session, otherwise SessionTimeSelect will try to pre-fill with an wrong id
        if (this.props.data.id !== nextProps.data.id) {
            let selectedTimeId = nextProps.sessionTime && nextProps.sessionTime.attendance ? nextProps.sessionTime.id : null;
            const sessionTimes = this.props.events && this.props.events.length && nextProps.session ? this.props.events.filter(e => e.parent_id === nextProps.session.id) : [];

            if (sessionTimes.length === 1) {
                selectedTimeId = sessionTimes[0].id;
            }

            state['values'] = {values: {sessionTimeId: selectedTimeId}};
        } else if (nextProps.sessionTime && nextProps.sessionTime.attendance) {
            state['values'] = {values: {sessionTimeId: nextProps.sessionTime.id}};
        }

        this.setState(state);
    }

    sessionAttendance() {
        return this.state.data && this.state.data.attendance ? this.state.data.attendance : {};
    }

    sessionTimeAttendance() {
        return this.state.sessionTime ? this.state.sessionTime.attendance : null;
    }

    sessionTime() {
        return this.state.sessionTime ? this.state.sessionTime : null;
    }

    session() {
        return this.state.data || {};
    }

    sessionTimes() {
        return this.state.events && this.state.events.length && this.state.data ? this.state.events.filter(e => e.parent_id === this.state.data.id) : [];
    }

    renderTitle() {
        // requires inline css as webkitBoxOrient can no longer be complied by SCSS
        return (
            <h3 className="sessionTitle" style={{webkitBoxOrient: 'vertical'}}>
                {this.session().title}
            </h3>
        );
    }

    openWebinarUrl() {
        const session       = this.session();
        const url           = session.webinar_url;
        const description   = session.webinar_description;
        const isOnline      = RsvpService.isOnline(session);
        const hasPassed     = RsvpService.hasEventPassed(this.sessionTime());
        WebinarService.openModal(url, description, isOnline, hasPassed);
    }

    selfCheckinHandler() {
        const sessionTime   = this.sessionTime() || {};
        const sessionTimeId = sessionTime.id;

        if (!sessionTimeId) return;

        // Navigate to stream page (when video_uuid is set on event)
        if (RsvpService.isOnline(this.session()) && sessionTime.video_uuid) {
            return RsvpService.goToStreamPage(sessionTimeId);
        } else {
            this.rsvpService.updateCheckin(sessionTimeId).then(() => {            
                // Refresh page and modal data
                RefreshData().then(SelfCheckinRefreshInterval).then(() => {
                    new GeckoToastService().success(__(STR_KEY.MODAL_SESSION_TOAST_UPDATED));
                    // Open webinar url 
                    this.openWebinarUrl();
                }).catch(err => new GeckoToastService().error(err));
            }).catch(err => new GeckoToastService().error(err));
        }
    }

    renderStatusControl() {
        // Maybe remove?
        if (!this.state.hasBooked) return null;

        const event = Object.assign({}, this.sessionTime(), {
            delivery_method: this.session().delivery_method,
            attendance: this.sessionAttendance()
        });

        return (
            <StatusControl 
                event={event}
                checkinHandler={() => this.selfCheckinHandler()}
                isSession={true}
             />
        );
    }

    renderDeliveryMethod() {
        const [str, icon] = RsvpService.getPrettyDeliveryMethod(this.session(), true);
        return (
            <div className="sessionLocation session-info-location">
                <i className={`fa-fw ${icon}`}></i>
                &nbsp;
                {str}
            </div>
        );
    }

    renderSessionTime() 
    {
        let sessionTime = this.sessionTime();

        if (!sessionTime) {
            // Fallback to session time 
            sessionTime = this.state.data;
        }

        return <SessionTime start={sessionTime.start_datetime} end={sessionTime.end_datetime} className="stubSeparator col-sm-3" />;
    }

    openSessionModal(id = null) {
        return new GeckoModalService().open(()=>{
            return (
                <GeckoModal className="modal-session-single" >
                    <SessionSingle id={id} event={this.state.event} />
                </GeckoModal>
            );
        }, {labelledBy: "sessionTitle"});
    }

    renderInfoBtn() {
        return (
            <div className="session-info-view-details">
                <i className={`fal fa-info-circle fa-fw `}></i>
                &nbsp;
                <span 
                    className="session-info-view-details-span" 
                    tabIndex={0} 
                    role='button' 
                    aria-label={__(STR_KEY.SESSIONS_LIST_VIEW_INFO)}
                    onKeyDown={e => this.handleKeyDown(e)} >
                    {__(STR_KEY.SESSIONS_LIST_VIEW_INFO)}
                </span>
            </div>
        );
    }


    renderStatus() {
        const attendance = this.sessionAttendance();
        if (attendance) {
            return (
                <div className="session-info-view-details">
                    <i className={`fal ${RSVP_CONSTS.ATTENDANCE.ICONS[attendance.status]} fa-fw `}></i>
                    &nbsp;
                    <span className="session-info-view-details-span">
                        {__(`status.${attendance.status}`)}
                    </span>
                </div>
            );    
        }
        return null;    
    }

    handleKeyDown(event){
        // Enter or Space keyCode
        if ([13, 32].includes(event.keyCode)){
            this.openSessionModal(this.state.data.id);
        }
    }

    render() {
        return (
            <div 
                className="session clearfix" 
                onClick={() => this.openSessionModal(this.state.data.id)} 
                >
                <CardStub>
                    <div className="row" style={{width: '100%', 'margin': 0}}>
                        
                        {this.renderSessionTime()}

                        <GeckoCol width="7 col-sm-9">
                            <div className="session-info">
                                {this.renderTitle()}
                                {this.renderInfoBtn()}
                                {this.renderDeliveryMethod()}                                
                                {this.renderStatus()}
                                <div className="session-btns">
                                    <div className="session-btns-item session-btns-item-action">
                                        {this.renderStatusControl()}
                                    </div>
                                </div>
                            </div>
                        </GeckoCol>
                    </div>
                </CardStub>
           </div>
        );
    }

}

Session.defaultProps = {
    data: {},
};

Session.propTypes = {
    data: PropTypes.object
};